export const signUp_style = {
  rootSx: {
    display: 'grid',
    gridTemplateRows: 'minmax(auto, 26%) minmax(auto, 74%)',
    backgroundColor: 'primary.lighter',
    gap: 3.5,
    minHeight: '100vh',
  },
};
